import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 03B09B13-4FA7-46CD-9E3B-48D460AB3986
 * name floor-lamp-torchiere-variant-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/floor-lamp-torchiere-variant-outline.svg
 * tags
 * - Home Automation 
 */
export const FloorLampTorchiereVariantOutlineIcon = createSvgIcon(<><path d="M13.97 4L12.68 7H11.32L10.03 4H13.97M17 2H7L10 9H14L17 2M15.92 22L13 15V22H11V15L8.08 22H5.92L10.92 10H13.08L18.08 22H15.92Z" /></>, 'FloorLampTorchiereVariantOutlineIcon');
export default FloorLampTorchiereVariantOutlineIcon